import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useProjetosService } from "../../../../../use-cases/geo-veles";
import { SkeletonVelesGeoProjectDetails } from "../../../../components/skeleton-veles";
import {
  AppBar,
  Button,
  Dialog,
  Skeleton,
  Toolbar,
  Typography,
} from "@mui/material";
import { useAppSelector } from "../../../../hooks/store-hooks";
import { BottomNavigation } from "./bottom-navigation";
import { Filtros } from "./filtros"; // Importando o componente Filtros
import { Detalhes } from "./detalhes/Detalhes";
import { useUIService } from "../../../../../use-cases/ui";

export const DetalhesDoProjeto = () => {
  // Use Params
  const { id } = useParams();
  // State
  const { projetoAberto, activeSection } = useAppSelector(
    (state) => state.projetos
  );
  const [loading, setLoading] = useState<boolean>(true);

  const access = useAppSelector((state) => state.user.access);

  // Hooks
  const { setProjetoAberto, 
          resetProjetoAberto, 
          setVerifyAcesso           
        } = useProjetosService();

  const { changeTitleAndMetaDesc } = useUIService();
  const navigate = useNavigate();
  // Ref to prevent multiple calls
  const hasFetched = useRef(false);

  useEffect(() => {
    if (id && !hasFetched.current) {
      setProjetoAberto(Number(id));

      setLoading(false);
      hasFetched.current = true;
    }
  }, [id, setProjetoAberto]);

  useEffect(() => {
    if (!access) {
      setVerifyAcesso();
    }
  })

  useEffect(() => {
    changeTitleAndMetaDesc({
      metaDesc: "Detalhes do projeto",
      title: "Veles_Geo - Projeto",
    });
  }, [changeTitleAndMetaDesc]);

  return (
    <>
      <Dialog
        open={true}
        onClose={() => navigate("/geo-veles/projetos")}
        fullScreen
        disableEscapeKeyDown
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <Typography
              sx={{ ml: 2, flex: 1 }}
              textTransform={"uppercase"}
              fontWeight={"bold"}
              variant="h6"
              component="div"
            >
              {loading ? (
                <Skeleton animation="wave" variant="text" width={300} />
              ) : (
                projetoAberto?.Nome ?? ""
              )}
            </Typography>
            <Button
              color="inherit"
              onClick={() => resetProjetoAberto()}
              aria-label="close"
              sx={{
                fontWeight: "bold",
              }}
            >
              Fechar
            </Button>
          </Toolbar>
        </AppBar>

        {/* Conteúdo Principal */}
        {loading ? (
          <SkeletonVelesGeoProjectDetails />
        ) : (
          <>
            {activeSection === "filtros" ? <Filtros /> : <Detalhes />}
            <BottomNavigation />
          </>
        )}
      </Dialog>
    </>
  );
};
